export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        coaches: action.coaches,
      };
    case 'DESTROY':
      return {
        ...state,
        coaches: state.coaches.filter((coach) => coach.attributes.user_id !== action.id),
      };
    case 'RESTORE':
      return {
        ...state,
        coaches: state.coaches.filter((coach) => coach.attributes.user_id !== action.id),
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
